import { render, staticRenderFns } from "./PointGpayCancel.vue?vue&type=template&id=d4afc2f6"
import script from "./PointGpayCancel.vue?vue&type=script&lang=js"
export * from "./PointGpayCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports